<template>
  <!-- Native position:sticky rather than the v-sticky directive — see the
       style block. -->
  <div :class="$options.name">
    <btn type="submit"
      class-name="btn--sm"
      icon="fa-solid fa-check">{{ saveLabel }}</btn>
    <btn type="button"
      variant="secondary"
      class-name="btn--sm"
      @click="$emit('cancel')">Tühista</btn>
    <div class="flex-auto" />
    <slot />
    <btn v-if="canDelete"
      variant="danger"
      class-name="btn--sm"
      icon="fa-solid fa-trash"
      confirm="Kas soovid selle kirje kustutada?"
      @click="$emit('delete')">Kustuta</btn>
  </div>
</template>

<script>
export default {
  name: 'form-toolbar',
  emits: ['cancel', 'delete'],
  props: {
    canDelete: { type: Boolean, default: false },
    saveLabel: { type: String, default: 'Salvesta' },
  }
}
</script>

<style scoped>
/* Replaces the vue3-sticky-directive this used to carry. That package parses
   its own attributes with a direct eval(), which rolldown flags and which a
   strict CSP would block — and this was its only use in the app. Native sticky
   needs no JS and behaves the same here: the bar pins to the bottom of the
   scrolling ancestor while the form is taller than the viewport. */
.form-toolbar {
  position: sticky;
  bottom: 0;
  z-index: 10;
  display: flex;
  gap: 20rem;
  padding: 10rem 24rem;
  background: var(--bg-surface-secondary);
  border-top: 1rem solid var(--border-color-light);
}

/* Three buttons at the wide spacing overflow a phone's modal. */
@media (max-width: 560px) {
  .form-toolbar {
    gap: 8rem;
    padding: 10rem 12rem;
  }
}
</style>
